import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Col, Container, Row } from 'reactstrap';
import './UsersList.css';
// import SortIcons from './ProposalsSortIcons';
import RequestsData from './RequestsData';
import { getUsersRequests } from '../actions/Users';
import { ReactComponent as RequestsUser } from '../Res/requests.svg'

const RequestsList = ({ }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;
  const updatedRequests = useSelector(state => state.AppState.requests);

  const [requestsData, setRequestsData] = useState([]);

  const userRequestData = async () => {
    await dispatch(getUsersRequests(token));
  }

  useEffect(() => {
    userRequestData();
  }, []);

  useEffect(() => {
    setRequestsData(updatedRequests?.pendingUsers);
  }, [updatedRequests]);

  const showUserRequests = () => {
    this.props.history.push('/users/approval-requests');
  }
  return (
    <div>
      <div className="filter-section">
        <Row>
          <Col md={12} sm={12} className="d-flex justify-content-end mr-5">
            <Button
              color="default"
              className="btn-circle btn-md"
              onClick={showUserRequests}
              style={{
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#EAECEF',
              }}
            >
              <RequestsUser
                width={55}
                height={55}

              />
            </Button>
          </Col>
        </Row>
      </div>
      <Container fluid className="customClass" style={{ margin: 0 }}>
        <div className="viewContainer" style={{ marginTop: '20px' }}>
          <div className="table-header-fixed">
            <table>
              <thead>
                <tr>
                  <th className="cursor-pointer" >
                    Name
                  </th>
                  <th className="cursor-pointer">
                    Email
                  </th>
                  <th className="cursor-pointer" >
                    Company Name
                  </th>
                  <th className="cursor-pointer" >
                    Granite Parent Account
                  </th>
                  <th className="cursor-pointer" >
                    Request Date
                  </th>
                  <th>Approve / Reject</th>
                  <th>3rd Party</th>
                  <th colSpan="1">Actions</th>
                </tr>
              </thead>
              <tbody>
                {requestsData?.length ? (
                  requestsData?.map(item => (
                    <RequestsData
                      item={item}
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan={9}>
                      <Alert rowSpan={9} color="info">
                        No Requests Found
                      </Alert>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default RequestsList;
